<nb-card class="sessao-expirada-card">
  <nb-card-header class="card-header-custom">
    <div class="header-content">
      <div class="header-title">
        <nb-icon icon="clock-outline" class="header-icon"></nb-icon>
        <h4>Sessão encerrada</h4>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body class="card-body-custom">
    <div class="sessao-expirada-body">
      <div class="relogio-container">
        <img
          class="relogio swing"
          src="assets/images/clock-red.png"
          alt="Sessão expirada"
        />
      </div>
      <p class="mensagem-principal">Sua sessão expirou por segurança.</p>
      <p class="mensagem-secundaria">
        Para continuar, faça login novamente. Seus dados não salvos podem ter sido perdidos.
      </p>
      <button nbButton status="primary" fullWidth size="large" (click)="confirmar()">
        <nb-icon icon="log-in-outline"></nb-icon>
        <span>Ir para o login</span>
      </button>
    </div>
  </nb-card-body>
</nb-card>
